import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-grocery',
  templateUrl: './icon-grocery.component.html',
  styleUrls: ['./icon-grocery.component.scss']
})
export class IconGroceryComponent implements OnInit {

  @Input() cssClass = 'icon--18';
  
  constructor() { }

  ngOnInit() {
  }

}
